import $ from "jquery";
import { debounce } from "../utils/functions";

const $window = $(window);
const $document = $(document);
const $body = $("body");
const $header = $(".header");
const $hamburger = $(".header__hamburger");
const $close = $(".navigation-menu__close");
const $navMenu = $(".navigation-menu");
const $navMenuTitle = $(".navigation-menu__title");
const $navSubmenuContainer = $(".navigation-submenu__container");
const $navSubmenuLink = $(".navigation-submenu__link");
const $navSubmenuLinkPopup = $(".navigation-submenu__link--has-popup");
const $navSubmenuClose = $(".navigation-submenu__close");
const $searchTrigger = $(".search__trigger");
const swipeTreshold = { x: 100, y: 100 };
const data = {
  startMousePos: { x: -1, y: -1 },
  endMousePos: { x: -1, y: -1 },
};

const toggleNav = () => {
  if ($navMenu.hasClass("navigation-menu--active")) {
    hideNav();
  } else {
    showNav();
  }
};

const showNav = () => {
  $navMenu.addClass("navigation-menu--active");
  navOverflow();
  $navMenu.on("scroll", navOverflow);
  $window.on("resize:height.navOverflow", debounce(navOverflow));
};

const hideNav = () => {
  $navMenu.scrollTop(0);
  $navMenu.removeClass("navigation-menu--active");
  $navMenu.off("scroll", navOverflow);
  $window.off("resize:height.navOverflow");
  hideAllMenus();
};

const navScrolledTop = () => $navMenu.scrollTop() === 0;
const navScrolledBottom = () =>
  Math.ceil($navMenu.scrollTop() + $navMenu.outerHeight()) >=
  Math.ceil($navMenu[0].scrollHeight);

const navOverflow = () => {
  if (navScrolledTop() && navScrolledBottom()) {
    $navMenu.addClass("navigation-menu--is-up navigation-menu--is-down");
  } else {
    if (navScrolledTop()) {
      $navMenu.addClass("navigation-menu--is-up");
    } else {
      $navMenu.removeClass("navigation-menu--is-up");
    }

    if (navScrolledBottom()) {
      $navMenu.addClass("navigation-menu--is-down");
    } else {
      $navMenu.removeClass("navigation-menu--is-down");
    }
  }
};

const toggleMenu = (trigger) => {
  const menu = trigger.parent().find(".navigation-submenu");
  if (menu.length !== 0) {
    if (menu.hasClass("navigation-submenu--active")) {
      hideAllMenus();
    } else {
      showMenu(trigger);
    }
  }
};

const showMenu = (trigger) => {
  hideAllMenus();
  const menu = trigger.parent().find(".navigation-submenu");
  if (menu.length !== 0) {
    if (menu.is(":hidden")) {
      menu.slideDown(300, function () {
        menu.addClass("navigation-submenu--active");
        navOverflow();
      });
    } else {
      menu.addClass("navigation-submenu--active");
    }
    trigger.addClass("navigation-menu__title--active");
    $header.addClass("header--menu-active");
  }
};

const toggleSubMenu = (trigger) => {
  const menu = trigger.parent().find(".navigation-sub-submenu");
  if (menu.length !== 0) {
    if (trigger.hasClass("navigation-submenu__link--active")) {
      hideSubMenus();
    } else {
      showSubMenu(trigger);
    }
  }
};

const showSubMenu = (trigger) => {
  hideSubMenus();
  let menu = trigger.parent().find(".navigation-sub-submenu");
  if (menu.length !== 0) {
    const $navSubmenuDesktop = trigger
      .closest(".navigation-submenu__container")
      .find(".navigation-submenu__submenu");

    if ($navSubmenuDesktop.is(":visible")) {
      $navSubmenuDesktop.html(menu.prop("outerHTML"));
      menu = $navSubmenuDesktop.children(".navigation-sub-submenu");
    }

    if (menu.is(":hidden")) {
      menu.slideDown(300, function () {
        menu.addClass("navigation-sub-submenu--active");
        navOverflow();
      });
    }
    trigger.addClass("navigation-submenu__link--active");
  }
};

const hideSubMenus = () => {
  const $activeMenus = $(".navigation-sub-submenu--active");
  $activeMenus.each(function () {
    const $thisEl = $(this);
    const attr = $thisEl.attr("style");
    if (typeof attr !== "undefined" && attr !== false) {
      $thisEl.slideUp(300, function () {
        $thisEl.removeAttr("style");
        navOverflow();
      });
    }
    $thisEl.removeClass("navigation-sub-submenu--active");
  });
  $(".navigation-submenu__link--active").removeClass(
    "navigation-submenu__link--active"
  );
  $(".navigation-submenu__submenu").html("");
};

const hideAllMenus = () => {
  const $activeMenus = $(
    ".navigation-submenu--active,.navigation-sub-submenu--active"
  );
  $activeMenus.each(function () {
    const $thisEl = $(this);
    const attr = $thisEl.attr("style");
    if (typeof attr !== "undefined" && attr !== false) {
      $thisEl.slideUp(300, function () {
        $thisEl.removeAttr("style");
        navOverflow();
      });
    }
    $thisEl.removeClass(
      "navigation-submenu--active navigation-sub-submenu--active"
    );
  });
  $(
    ".navigation-menu__title--active,.navigation-submenu__link--active"
  ).removeClass(
    "navigation-menu__title--active navigation-submenu__link--active"
  );
  $(".navigation-submenu__submenu").html("");
  $header.removeClass("header--menu-active");
};

function onTouchStart(event, data) {
  const evt =
    typeof event.originalEvent === undefined ? event : event.originalEvent;
  const touch = evt.touches[0] || evt.changedTouches[0];
  data.startMousePos.x = touch.pageX;
  data.startMousePos.y = touch.pageY;
}

function onTouchEnd(event, data) {
  const evt =
    typeof event.originalEvent === undefined ? event : event.originalEvent;
  const touch = evt.touches[0] || evt.changedTouches[0];
  data.endMousePos.x = touch.pageX;
  data.endMousePos.y = touch.pageY;

  const mousePosDiff = {
    x: data.startMousePos.x - data.endMousePos.x,
    y: data.startMousePos.y - data.endMousePos.y,
  };

  data.startMousePos = { x: -1, y: -1 };
  data.endMousePos = { x: -1, y: -1 };

  if (Math.abs(mousePosDiff.x) > swipeTreshold.x) {
    if (mousePosDiff.x > 0) {
      if ($navMenu.hasClass("navigation-menu--active")) {
        hideNav();
      }
    } else {
      if (
        $(touch.target).closest(
          ".slider,.carroussel,.wp-block-table,.about-timeline-carousel,.service-carousel"
        ).length === 0
      ) {
        if (!$navMenu.hasClass("navigation-menu--active")) {
          showNav();
        }
      }
    }
  }
}

$window.on("resize:width", debounce(hideNav, true));
$hamburger.on("click", function (event) {
  event.stopPropagation();
  toggleNav();
});
$close.on("click", hideNav);
$navMenu.on("click", function (event) {
  if ($navMenu.hasClass("navigation-menu--active")) {
    event.stopPropagation();
  }
});
$navSubmenuContainer.on("click", function (event) {
  event.stopPropagation();
});
$navSubmenuClose.on("click", function () {
  hideAllMenus();
});

let navMenuTitleClick = false;
$navMenuTitle
  .on("click", function (event) {
    event.stopPropagation();
  })
  .on("mousedown", function () {
    navMenuTitleClick = true;
    toggleMenu($(this));
  })
  .on("focus", function () {
    if (!navMenuTitleClick) {
      showMenu($(this));
    }
    navMenuTitleClick = false;
  });

let navSubmenuLinkClick = false;
$navSubmenuLink
  .on("click", function (event) {
    event.stopPropagation();
  })
  .on("mousedown", function () {
    navSubmenuLinkClick = true;
    toggleSubMenu($(this));
  })
  .on("focus", function () {
    if (!navSubmenuLinkClick) {
      showSubMenu($(this));
    }
    navSubmenuLinkClick = false;
  });

$body.on("click", hideNav);
$searchTrigger.on("click", hideNav);

$body.on("touchstart", function (event) {
  onTouchStart(event, data);
});
$body.on("touchend", function (event) {
  onTouchEnd(event, data);
});

$navSubmenuLinkPopup.on("keydown", function (e) {
  const $navSubmenuDesktop = $(this)
    .closest(".navigation-submenu__container")
    .find(".navigation-submenu__submenu");

  if ($navSubmenuDesktop.is(":visible")) {
    if (e.key === "Enter") {
      $navSubmenuDesktop
        .find(".navigation-sub-submenu__link")
        .first()
        .trigger("focus");
    }
  }
});
$document.on("keydown", ".navigation-sub-submenu__link", function (e) {
  const $thisEl = $(this);
  const $navSubmenuDesktop = $thisEl.closest(".navigation-submenu__submenu");

  if ($navSubmenuDesktop.is(":visible")) {
    if (
      $navSubmenuDesktop.find(".navigation-sub-submenu__link").last().get(0) ===
      $thisEl.get(0)
    ) {
      if (e.key === "Tab") {
        const $parentLink = $thisEl
          .closest(".navigation-submenu__container")
          .find(".navigation-submenu__link--active");

        if (
          $parentLink.get(0) !==
          $parentLink
            .closest(".navigation-submenu__menu")
            .find(".navigation-submenu__link")
            .last()
            .get(0)
        ) {
          $parentLink.trigger("focus");
        }
      }
    }
  }
});
